// @module AwaLabs.PartiesEvents
define('PartiesEvents.View', [
    'parties_events_form.tpl',
    'Backbone',
    'Backbone.FormView',
    'SC.Configuration',
    'Tracker',
    'underscore',
    'jQuery'
], function PartiesEventsView(
    template,
    Backbone,
    BackboneFormView,
    Configuration,
    Tracker,
    _,
    jQuery
) {
    'use strict';

    var title = Configuration.get('PartiesEventsConfig.title') || 'Parties & Events';
    var route = Configuration.get('PartiesEventsConfig.url') || 'parties-events';
    var time = Configuration.get('PartiesEventsConfig.errorTimeDuration');
    var metaDescription = Configuration.get('PartiesEventsConfig.metaDescription') || 'Parties & Events form';

    return Backbone.View.extend({
        template: template,
        title: _(title).translate(),
        page_header: _(title).translate(),
        metaDescription: _(metaDescription).translate(),

        events: {
            'submit form': 'saveTheForm',
            'change [name="custevent_aws_delivery_option"]': 'enableDeliveryOptions',
            'change [name="custevent_aws_full_bar"]': 'enableTypeSpiritsOptions',
            'change [data-selection="validate"]': 'activateValidation',
            'change [name="custevent_aws_champagne"]': 'enableRequiredFieldPPB'
        },

        bindings: {
            '[name="title"]': 'title',
            '[name="firstname"]': 'firstname',
            '[name="lastname"]': 'lastname',
            '[name="custevent_aws_billing_adress"]': 'custevent_aws_billing_adress',
            '[name="city"]': 'city',
            '[name="state"]': 'state',
            '[name="zipcode"]': 'zipcode',
            '[name="phone"]': 'phone',
            '[name="email"]': 'email',
            '[name="custevent_awa_event_contact_name"]': 'custevent_awa_event_contact_name',
            '[name="custevent_awa_event_contact_phone"]': 'custevent_awa_event_contact_phone',
            '[name="custevent_aws_event_date"]': {
                observe: 'custevent_aws_event_date',
                events: ['change', 'blur']
            },
            '[name="custevent_awa_event_start_time"]': 'custevent_awa_event_start_time',
            '[name="custevent_awa_venue_name"]': 'custevent_awa_venue_name',
            '[name="custevent_awa_venue_address"]': 'custevent_awa_venue_address',
            '[name="custevent_aws_delivery_option"]': 'custevent_aws_delivery_option',
            '[name="custevent_aws_delivery_date"]': {
                observe: 'custevent_aws_delivery_date',
                events: ['change', 'blur']
            },
            '[name="custevent_aws_delivery_time_window"]': 'custevent_aws_delivery_time_window',
            '[name="custevent_aws_guest_count"]': 'custevent_aws_guest_count',
            '[name="custevent_aws_percetage_allotted"]': 'custevent_aws_percetage_allotted',
            '[name="custevent_aws_amount_serving_hours"]': 'custevent_aws_amount_serving_hours',
            '[name="custevent_awa_type_of_spirit"]': 'custevent_awa_type_of_spirit',
            '[name="custevent_aws_quality"]': 'custevent_aws_quality',
            '[name="custevent_aws_signature_cocktails"]': 'custevent_aws_signature_cocktails',
            '[name="custevent_awa_need_mixers_text"]': 'custevent_awa_need_mixers_text',
            '[name="custevent_awa_glass_red_wine_restricted"]': 'custevent_awa_glass_red_wine_restricted',
            '[name="custevent_awa_preferred_beer"]': 'custevent_awa_preferred_beer',
            '[name="custevent_aws_beer_requests"]': 'custevent_aws_beer_requests',
            '[name="custevent_awa_wine_type_text"]': 'custevent_awa_wine_type_text',
            '[name="custevent_aws_wine_price_range"]': 'custevent_aws_wine_price_range',
            '[name="custevent_awa_specific_wine_style"]': 'custevent_awa_specific_wine_style',
            '[name="custevent_aws_champagne"]': 'custevent_aws_champagne',
            '[name="custevent_aws_champagne_price"]': 'custevent_aws_champagne_price',
            '[name="custevent_aws_sodas"]': 'custevent_aws_sodas',
            '[name="custevent_aws_referenced_by"]': 'custevent_aws_referenced_by',

            '[name="incomingmessage"]': 'incomingmessage'
        },

        attributes: {
            'class': 'partiesform'
        },

        enableDeliveryOptions: function enableDeliveryOptions(e) {
            var selected = jQuery(e.currentTarget);
            if (selected.val() === '2') {
                jQuery('#delivery-options-group .contact-us-form-required').removeClass('hidden');
            }
            if (selected.val() === '1') {
                jQuery('#delivery-options-group .contact-us-form-required').addClass('hidden');
            }
        },
        enableRequiredFieldPPB: function enableRequiredFieldPPB(e) {
            var selected = this.$(e.currentTarget);
            if (selected.length > 0 && selected[0].checked === true) {
                jQuery('#price-per-bottle .contact-us-form-required').removeClass('hidden');
            } else {
                jQuery('#price-per-bottle .contact-us-form-required').addClass('hidden');
            }
        },
        activateValidation: function activateValidation(e) {
            var selected = jQuery(e.currentTarget);
            var selectedValidation = selected.data('validation');
            var checkBoxes = jQuery('#spirit-option-validation-fildset input[value="' + selectedValidation + '"]');
            checkBoxes.prop('checked', !checkBoxes.prop('checked'));
        },
        enableTypeSpiritsOptions: function enableTypeSpiritsOptions(e) {
            var selected = jQuery(e.currentTarget);
            if (selected.is(':checked')) {
                jQuery('#type-spirits-options .contact-us-form-required').removeClass('hidden');
            } else {
                jQuery('#type-spirits-options .contact-us-form-required').addClass('hidden');
            }
        },

        getBreadcrumbPages: function getBreadcrumbPages() {
            return [{
                text: _(title).translate(),
                href: '/' + route
            }];
        },

        initialize: function initialize(options) {
            this.options = options;
            this.application = options.application;
            BackboneFormView.add(this);
            this.model.on('sync', jQuery.proxy(this, 'showSuccess'));
        },

        // Prevents not desired behaviour when hitting enter
        preventEnter: function preventEnter(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
            }
        },


        saveTheForm: function saveTheForm(e) {
            var self = this;
            var promise = BackboneFormView.saveForm.apply(this, arguments);
            e.preventDefault();

            Tracker.getInstance().trackEvent({
                name: 'partiesEventsFormSubmit',
                category: 'parties-events',
                action: 'formSubmit',
                label: 'formSubmit',
                value: ''
            });

            self.submitButton = this.$('#submit-button')[0];
            self.submitButton.disabled = true;

            if (!promise) {
                self.submitButton.disabled = false;
            }

            return promise && promise.then(function promiseSuccessCallback(data) {
                if (data.successMessage) {
                    self.showMessage(data.successMessage, 'success');
                    self.$('form').get(0).reset();

                    Tracker.getInstance().trackEvent({
                        name: 'partiesEventsFormSubmitted',
                        category: 'parties-events',
                        action: 'formSubmitted',
                        label: 'formSubmitted',
                        value: ''
                    });
                } else {
                    self.showMessage('Error occurred, please try again.', 'error');
                }
                self.submitButton.disabled = false;
            }, function promiseErrorCallback(jqXhr) {
                jqXhr.preventDefault = true;
                self.showMessage(jqXhr.responseJSON.errorMessage, 'error');
                self.submitButton.disabled = false;
            });
        },

        showMessage: function showMessage(message, type) {
            var $message = this.$('.message').removeClass('hide message-success message-error');
            if (type === 'success') {
                $message.addClass('message-success');
            } else {
                $message.addClass('message-error');
            }
            $message.text(message).fadeIn(400).delay(time).fadeOut();
        },

        getContext: function getContext() {
            // @class PartiesForm.View.Context
            return {
                // @property {String} pageHeader
                pageHeader: this.page_header
            };
        }
    });
});
